// https://prod-henk-search.search.windows.net/indexes/henk-abp-articles-test/docs?api-version=2020-06-30-Preview&search=*
export default class AzureSearchApiSettings {
  constructor(settings) {
    this.searchServiceName = null;
    this.searchServiceAdminApiKey = '3E38B7294291D1EEFEB4565B5384F36D';
    this.searchServiceQueryApiKey = '421932712F8217C1C7C50B881E8129A4';
    this.indexName = 'henk-abp-articles-test';
    this.apiVersion = '2017-11-11';
    this.url = 'https://prod-henk-search.search.windows.net';
    this.corsSettings = [];
    if (settings) {
      if (settings.searchServiceName)
        { this.searchServiceName = settings.searchServiceName; };
      if (settings.searchServiceAdminApiKey)
        { this.searchServiceAdminApiKey = settings.searchServiceAdminApiKey; };
      if (settings.searchServiceQueryApiKey)
        { this.searchServiceQueryApiKey = settings.searchServiceQueryApiKey; };
      if (settings.indexName) this.indexName = settings.indexName;
      if (settings.apiVersion) this.apiVersion = settings.apiVersion;
      if (settings.url) this.url = settings.url;
      if (settings.corsSettings) this.corsSettings = settings.corsSettings;
    }
  }
}
